export default "__VITE_ASSET__8xYqFuyb__"